import styles from "./HelpModal.module.css";
import { useLanguage } from "../../../context/LanguageContext";
import Modal from "../Modal";

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function HelpModal({ isOpen, onClose }: HelpModalProps) {
  const { t } = useLanguage();

  const shortcuts = [
    { 
      category: t("help"),
      items: [
        { key: "F1", description: t("openHelp")}
      ]
    },

    { 
      category: t("crudOperations"),
      items: [
        { key: "Alt+N", description: t("addNewRow")},
        { key: "Ctrl+E", description: t("editSelectedRow")},
        { key: "Ctrl+D", description: t("deleteSelectedRow")},
        { key: "Ctrl+Enter", description: t("saveChanges") },
        { key: "Esc", description: t("cancelEdit")}
      ]
    },

    { 
      category: t("navigation"),
      items: [
        { key: "↓", description: t("selectNextRow")},
        { key: "↑", description: t("selectPreviousRow")},
        { key: "Tab", description: t("nextColumn")},
        { key: "Shift+Tab", description: t("prevColumn")},
      ]
    },

    { 
      category: t("pagination"),
      items: [
        { key: "Page Down", description: t("nextPage")},
        { key: "Page Up", description: t("previousPage")},
        { key: "Home", description: t("firstPage")},
        { key: "End", description: t("lastPage")}
      ]
    },

    { 
      category: t("filters"),
      items: [
        { key: "F9", description: t("openFilterModal")}
      ]
    },

    { 
      category: t("columns"),
      items: [
        { key: "Ctrl+Shift+S", description: t("sortColumn")},
        { key: "Ctrl+Shift+E", description: t("manageColumns")}
      ]
    },

    { 
      category: t("clipboard"),
      items: [
        { key: "Ctrl+C", description: t("copyRow")},
        { key: "Ctrl+V", description: t("pasteAsTable")},
        { key: "Ctrl+Shift+V", description: t("pasteValues")}
      ]
    },

    { 
      category: t("browser"),
      items: [
        { key: "Alt+←", description: t("goBack")},
        { key: "Alt+→", description: t("goForward")}
      ]
    }
  ];

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose} 
      title={t("keyboardShortcuts")}
    >
      <div className={styles.helpContent}>
        {shortcuts.map((section, sectionIndex) => (
          <div key={sectionIndex} className={styles.shortcutSection}>
            <h3 className={styles.sectionTitle}>{section.category}</h3>
            <div className={styles.shortcutsContainer}>
              {section.items.map((shortcut, index) => (
                <div key={index} className={styles.shortcutRow}>
                  <kbd className={styles.key}>{shortcut.key}</kbd>
                  <span className={styles.description}>{shortcut.description}</span>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className={styles.notes}>
          <p className={styles.note}>
            <strong>{t("note")}:</strong> {t("hotkeyNote")}
          </p>
        </div>
      </div>
    </Modal>
  );
}